import { useEffect, useRef } from 'react';
import { useNavigate } from '@tanstack/react-router';
import Loading from '@/components/Loading';
import type { AgentApiJobPostImportRequestsRecord } from '@/types/serializers';
import { Button } from '@/components/Button';
import { Link } from '@tanstack/react-router';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';

type Props = {
  importRequest: AgentApiJobPostImportRequestsRecord;
};

export function JobPostImportRequestsProcessingTemplate({ importRequest }: Props) {
  const navigate = useNavigate();
  const hasShownToastRef = useRef(false);

  useEffect(() => {
    if (importRequest.status === 'completed' && !hasShownToastRef.current) {
      hasShownToastRef.current = true;
      showSuccessToast('求人データの取り込みが完了しました');
      setTimeout(() => {
        navigate({
          to: '/agent/provided_job_posts',
        });
      }, 500);
    }
  }, [importRequest.status, navigate]);

  return (
    <div className="flex h-full flex-col items-center justify-center p-6">
      <Loading size="small" />
      <p className="mt-2 text-sm text-gray-600">
        CSVから求人データを取り込み中です。しばらくお待ち下さい。
      </p>
      <Button color="tertiary" size="md" asChild className="mt-4">
        <Link to="/agent/provided_job_posts" className="flex items-center gap-1" target="_blank">
          <span>求人票一覧へ</span>
          <MdKeyboardArrowRight size={16} />
        </Link>
      </Button>
    </div>
  );
}
